var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "g",
    {
      staticClass:
        "gantt-elastic__chart-row-bar-wrapper gantt-elastic__chart-row-task-wrapper",
      style: Object.assign(
        {},
        _vm.root.style["chart-row-bar-wrapper"],
        _vm.root.style["chart-row-task-wrapper"],
        _vm.task.style["chart-row-bar-wrapper"]
      )
    },
    [
      _vm.displayExpander
        ? _c(
            "foreignObject",
            {
              staticClass:
                "gantt-elastic__chart-expander gantt-elastic__chart-expander--task",
              style: Object.assign(
                {},
                _vm.root.style["chart-expander"],
                _vm.root.style["chart-expander--task"],
                _vm.task.style["chart-expander"]
              ),
              attrs: {
                x:
                  _vm.task.x -
                  _vm.root.state.options.chart.expander.offset -
                  _vm.root.state.options.chart.expander.size,
                y:
                  _vm.task.y +
                  (_vm.root.state.options.row.height -
                    _vm.root.state.options.chart.expander.size) /
                    2,
                width: _vm.root.state.options.chart.expander.size,
                height: _vm.root.state.options.chart.expander.size
              }
            },
            [
              _c("expander", {
                attrs: {
                  tasks: [_vm.task],
                  options: _vm.root.state.options.chart.expander,
                  type: "chart"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass:
            "gantt-elastic__chart-row-bar gantt-elastic__chart-row-task",
          style: Object.assign(
            {},
            _vm.root.style["chart-row-bar"],
            _vm.root.style["chart-row-task"],
            _vm.task.style["chart-row-bar"]
          ),
          attrs: {
            x: _vm.task.x,
            y: _vm.task.y,
            width: _vm.task.width,
            height: _vm.task.height,
            viewBox: "0 0 " + _vm.task.width + " " + _vm.task.height,
            xmlns: "http://www.w3.org/2000/svg"
          },
          on: {
            click: function($event) {
              return _vm.onBarClick($event)
            },
            mouseenter: function($event) {
              return _vm.emitEvent("mouseenter", $event)
            },
            mouseover: function($event) {
              return _vm.emitEvent("mouseover", $event)
            },
            mouseout: function($event) {
              return _vm.emitEvent("mouseout", $event)
            },
            mousemove: function($event) {
              return _vm.emitEvent("mousemove", $event)
            },
            mousedown: function($event) {
              return _vm.emitEvent("mousedown", $event)
            },
            mouseup: function($event) {
              return _vm.emitEvent("mouseup", $event)
            },
            mousewheel: function($event) {
              return _vm.emitEvent("mousewheel", $event)
            },
            touchstart: function($event) {
              return _vm.emitEvent("touchstart", $event)
            },
            touchmove: function($event) {
              return _vm.emitEvent("touchmove", $event)
            },
            touchend: function($event) {
              return _vm.emitEvent("touchend", $event)
            }
          }
        },
        [
          _c("rect", {
            staticClass:
              "gantt-elastic__chart-row-bar-polygon gantt-elastic__chart-row-task-polygon",
            style: Object.assign(
              {},
              _vm.root.style["chart-row-bar-polygon"],
              _vm.root.style["chart-row-task-polygon"],
              _vm.task.style["base"],
              _vm.task.style["chart-row-bar-polygon"]
            ),
            attrs: {
              x: "0",
              y: "0",
              width: "100%",
              height: "100%",
              rx: "5",
              ry: "5"
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.root.state.options.chart.title.display
        ? _c(
            "foreignObject",
            {
              attrs: {
                x: _vm.task.x - _vm.root.state.options.chart.title.offsetX,
                y: _vm.task.y - _vm.root.state.options.chart.title.offsetY,
                width: _vm.task.width,
                height: _vm.task.height
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "gantt-elastic__chart-row-title-wrapper",
                  style: Object.assign(
                    {},
                    _vm.task.style["chart-row-title-wrapper"]
                  ),
                  attrs: {
                    xmlns: "http://www.w3.org/1999/xhtml",
                    task: _vm.task
                  }
                },
                [
                  !_vm.root.state.options.chart.title.html
                    ? _c(
                        "div",
                        {
                          staticClass: "gantt-elastic__chart-row-title-text",
                          style: Object.assign(
                            {},
                            _vm.task.style["chart-row-title-text"],
                            _vm.task.style["chart-row-title-text--text"]
                          ),
                          attrs: { task: _vm.task }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(_vm.task.title) + "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.root.state.options.chart.title.html
                    ? _c("div", {
                        staticClass: "gantt-elastic__chart-row-title-text",
                        style: Object.assign(
                          {},
                          _vm.task.style["chart-row-title-text"],
                          _vm.task.style["chart-row-title-text--html"]
                        ),
                        attrs: { task: _vm.task },
                        domProps: { innerHTML: _vm._s(_vm.task.title) }
                      })
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.root.state.options.chart.text.display
        ? _c("chart-text", { attrs: { task: _vm.task } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }